function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}
/**
 * 日期格式化
 */
export function dateFormat(date) {
  let format = 'yyyy-MM-dd hh:mm:ss'
  if (date != 'Invalid Date') {
    var o = {
      'M+': date.getMonth() + 1, // month
      'd+': date.getDate(), // day
      'h+': date.getHours(), // hour
      'm+': date.getMinutes(), // minute
      's+': date.getSeconds(), // second
      'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
      'S': date.getMilliseconds() // millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(RegExp.$1,
          RegExp.$1.length == 1 ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length))
      }
    }
    return format
  }
  return ''
}
function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime())
}
export function yearFormat(date) {    //只显示年月日
  if (date) {
    return date.slice(0, 10)
  } else {
    return ''
  }
}
export function yearFormats(date) {    //只显示年月日
  if (date) {
    let newDate;
    if (typeof date == String) {
      newDate = new Date(date.replace("-", "/").replace("-", "/"))
    } else {
      newDate = new Date(date)
    }
    if (!isValidDate(newDate)) {
      return ''
    } else {
      let year = newDate.getFullYear(),
        month = newDate.getMonth() + 1,
        day = newDate.getDate()
      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (day < 10 ? '0' + day : day)
    }
  } else {
    return ''
  }
}

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }

  if ((time + '').length === 10) {
    time = +time * 1000
  }

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    date = new Date(parseInt(time))
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

/* 数字 格式化 */
export function nFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function toThousandslsFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

export function tosex(id) {             //性别
  if (!id) return ""
  else
    return { "1": "男", "2": '女' }[id]
}

export function payee(type) {             //
  if (!type) return ''
  else {
    return {
      1: '否',
      2: '刑事自诉',
      3: '检察院公诉',
      4: '准备中'
    }[type]
  }
}

export function torelation(id) {            //关系
  return { "2": "共同债务人-配偶","5": "共同债务人-其他", "3": '连带担保人-配偶', "4": '连带担保人-其他' }[id]
}

export function tocarName(carid, carList) {            //车型
  if (carList) {
    let car = carList.filter(ele => {
      return ele.id === carid
    })
    return car.length > 0 ? car[0].title : ''
  }
}

export function toNum(x) {
  let f = parseFloat(x);
  if (isNaN(f)) {
    return;
  }
  f = Math.round(x * 100) / 100;
  return f.toFixed(2);

}
export function showYuan(num) {
  if (num) {
    if (num > 0 || num < 0) {
      return (num / 100).toFixed(2)
    }
    return num
  } else {
    return 0
  }

}
export function douYuan(num) {    //部分金钱显示需要显示逗号
  if (num) {
    if (num > 0 || num < 0) {
      num = (num / 100).toFixed(2)
    }
    return Number(num).toLocaleString()
  } else {
    return 0
  }

}

export function rCar(type) {
  if (type) {
    return ['不详', '是', '否', '法院扣押', '原告自行留置', '被告主动交付', '原告提供线索由法院扣押'][type]
  } else {
    return '否'
  }
}



export function diffMonth(n) {
  let dt = new Date();
  dt.setMonth(dt.getMonth() + Number(n));
  let newData = dt.toLocaleString().replace(/\//g, '-');
  return newData
}

export function NullTit(val) {
  return val ? val.title : ''
}


export function toTypeName(step, name) {
  // console.log([43, 53].indexOf(step))
  if ([43, 53].indexOf(step * 1) >= 0) {
    return '调解'
  } else {
    return name
  }
}


// export function rTime (n) {
//   return {
//     now: diffMonth(-n).slice(0, 10),
//     later: diffMonth(n).slice(0, 10)
//   }
// }

